import { render, staticRenderFns } from "./OrderCreatedMessage.vue?vue&type=template&id=2752f942&"
import script from "./OrderCreatedMessage.vue?vue&type=script&lang=js&"
export * from "./OrderCreatedMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports